<template>
  <div class="fillcontain">
    <div v-loading="loading" class="table_container">
      <div class="myel-tabs-container">
        <el-tabs  v-model="activeName" type="card" style="height:400px;" @tab-click="handleClick">
          <el-tab-pane  label="个人网银" name="user">
            <div>
              <div>
                <ul class="bankList">
                  <li
                    class="bankListItem"
                    @click="()=>bankClick(item,index,1)"
                    v-for="(item,index) in userbank"
                    :index="index+'userbank'"
                  >
                    <span
                      v-bind:style="{backgroundPosition:'0 '+renderUserPosition(index)+'px'}"
                      class="bankbgimage"
                    ></span>
                  </li>
                </ul>
                <div class="tips">
                  <i class="el-icon-warning-outline"></i>请确认已经插入企业UKEY 且正在使用IE浏览器 以便正常使用网上银行支付。
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="企业网银" name="company">
            <div>
              <div>
                <ul class="bankList">
                  <li
                    class="bankListItem"
                    @click="()=>bankClick(item,index,2)"
                    v-for="(item,index) in companybank"
                    :index="index+'companybank'"
                  >
                    <span
                      v-bind:style="{backgroundPosition:'0 '+renderCompanyPosition(index)+'px'}"
                      class="bankbgimage"
                    ></span>
                  </li>
                </ul>
                <div class="tips">
                  <i class="el-icon-warning-outline"></i>请确认已经插入企业UKEY 且正在使用IE浏览器 以便正常使用网上银行支付。
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { userbank, companybank } from "../../config/bank";
import { toEbank } from "@/api/api";

export default {
  props:['id'],
  data() {
    return {
      userbank,
      companybank,
      activeName: "company",
      loading: false
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  watch: {
    $route() {}
  },
  mounted() {},
  components: {},
  methods: {
    bankClick(item, index, type) {
      this.loading = true;
      let that = this;
      let url = toEbank;
      let data = {
        access_token: this.userInfo.access_token,
        order_id: this.id,
        gate_id: item.code,
        bank_type: type,
        type:1
      };

      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({
        method: "post",
        data: param,
        url
      })
        .then(function(res) {
          console.log("res", res);

          if (parseInt(res.data.resultCode) === 1) {
            console.log(res.data.data);
            //  that.initMeetLIst({},that.pagination.currentPage-1,that.pagination.size)
            window.location.href = res.data.data;

            //  window.location.href=getContextPath(res.data.data)+"/jurisdiction/jumpAddAccessPath.action;
          } else {
            that.loading = false;
            that.$alert(res.data.resultMsg);
          }
        })
        .catch(function(err) {
          that.loading = false;
          that.$alert(err.msg);
        });
    },
    renderCompanyPosition(index) {
      let base = -28;
      switch (index) {
        case 0:
          return 30 * base;
        case 1:
          return 19 * base;
        case 2:
          return 5 * base;
        case 3:
          return 12 * base;
        case 4:
          return 14 * base;
        case 5:
          return 28 * base;
        case 6:
          return 16 * base;
        case 7:
          return 6 * base;
        case 8:
          return 11 * base;
        case 9:
          return 7 * base;
        case 10:
          return 27 * base;
        case 11:
          return 21 * base;
        case 12:
          return 32 * base;
      }
    },
    renderUserPosition(index) {
      let base = -28;
      switch (index) {
        case 0:
          return 5 * base;
        case 1:
          return 28 * base;
        case 2:
          return 19 * base;
        case 3:
          return 12 * base;
        case 4:
          return 16 * base;
        case 5:
          return 7 * base;
        case 6:
          return 11 * base;
        case 7:
          return 31 * base;
        case 8:
          return 30 * base;
        case 9:
          return 6 * base;
        // case 10:
        //   return 14*base;
        case 10:
          return 32 * base;
        // case 12:
        //   return 1*base;
        case 11:
          return 20 * base;
        case 12:
          return 27 * base;
        case 13:
          return 21 * base;
        // case 16:
        //   return 153*base;
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    goBack() {
      this.$router.go(-1);
    },
    onSubmit() {}
  }
};
</script>

<style scoped lang="less">
// @import '../style/mixin';

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.tips {
  color: #666;
  font-size: 12px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.Pagination {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.table_container_header {
  height: 50px;
}

.item_container {
  margin-top: 20px;
}

.upload_container {
  height: 100px;
}

.updata_tips {
  font-size: 10px;
  color: #666;
}

.updata_tips_err {
  color: #666;
  font-size: 10px;
}
.myel-tabs-container {
  margin-top: 10px;
}

.recordcheck .el-button--primary {
  position: relative;
  z-index: 1;
}
.bankList {
  width: 800px;
  overflow: hidden;
  margin-top: 15px;
}
.bankListItem {
  float: left;
  width: 188px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-content: center;
  border: 1px solid #c9dfff;
  margin-right: 10px;
  margin-bottom: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
}
.bankbgimage {
  width: 125px;
  height: 28px;
  background-image: url(../../assets/img/bank_logo.png);
}
.bankListItem:hover {
  border: 1px solid #e31613;
}
</style>



// WEBPACK FOOTER //
// src/components/components/EBankRechart.vue